import React from "react";
import splash from "../../assets/video/splash.mp4";

const SplashVideo = () => {
  return (
   
    <div
      style={{
        width: "100%",
        height: "100vh",
        position: "absolute",
        zIndex: 1000000,
      }}
    >
      <video
        width="100%"
        height="100%"
        src={splash}
        type="video/mp4"
        autoPlay
        style={{
          objectFit: "cover",
        }}
        controls={false}
      />
    </div>
  );
};

export default SplashVideo;
